import Input from "components/Elements/Inputv2";
import React, { FC } from "react";
import { SendingServiceSettingsProps } from "../WhatsappSettings";

const TwilioSettings: FC<SendingServiceSettingsProps> = ({
  formData,
  setFormData,
}) => {
  return (
    <div className="p-5 flex justify-center font-inter text-[14px] font-normal leading-[22px] text-[#111827]">
      <div className="max-w-[970px] w-full flex flex-col gap-5">
        <div className="bg-white p-5 flex flex-col gap-5">
          <div className="flex flex-col gap-[5px]">
            <div>Whatsapp account SID</div>
            <Input
              id="twilio-account-sid-input"
              wrapperClassName="!w-full"
              className="w-full"
              value={formData.whatsappAccountSid}
              onChange={(value) =>
                setFormData({ ...formData, whatsappAccountSid: value })
              }
              placeholder="Whatsapp Account Sid"
            />
          </div>

          <div className="flex flex-col gap-[5px]">
            <div>Whatsapp auth token</div>
            <Input
              id="twilio-auth-token-input"
              wrapperClassName="!w-full"
              className="w-full"
              value={formData.whatsappAuthToken}
              onChange={(value) =>
                setFormData({ ...formData, whatsappAuthToken: value })
              }
              placeholder="Whatsapp Auth Token"
            />
          </div>

          <div className="flex flex-col gap-[5px]">
            <div>WhatsApp From </div>
            <Input
              id="twilio-auth-token-input"
              wrapperClassName="!w-full"
              className="w-full"
              value={formData.whatsappFrom}
              onChange={(value) =>
                setFormData({ ...formData, whatsappFrom: value })
              }
              placeholder="Whatsapp From"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwilioSettings;
